import {
  put, select, call, takeLatest,
} from 'redux-saga/effects';
import { SORT_REQUEST } from '../constants';
import * as Selectors from '../selectors';
import { getTrips } from '../../../shared/api/origo';
import { sortSuccessAction } from '../actions';

export function* sortRequest() {
  const settings = yield select(Selectors.getSettings);
  const query = yield select(Selectors.getCurrentFilterParams);

  try {
    const result = yield call(getTrips, settings, { ...query });

    yield put(sortSuccessAction({ ...result }));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to sort lms departures, call got error ');
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* sortRequestSaga() {
  yield takeLatest([SORT_REQUEST], sortRequest);
}
